<template>
    <div class="box-body bg-round bg-fff" :style="'margin-bottom: '+footbottom+'px;'">
        <div class="container">
            <header id="header">
                <div class="flex f-around">
                    <div class="header-li" @click="toPage('/competition/short')">短片奖（Short Film Award）</div>
                    <div class="header-li" @click="toPage('/competition/scenario')">剧本大赛（Script）</div>
                    <div class="header-li" @click="toPage('/plan/media')">创作扶持（Creation）</div>
                    <div class="header-li" @click="toPage('/competition/winner')">获奖作品（Winners）</div>
                    <div class="header-li header-active" @click="toPage('/merge/Activity')">展映活动（Exhibition）</div>
                </div>
            </header>
        </div>
        <div class="container con-top mb-md-4" id="app" >
            <div v-cloak>
                <el-carousel :interval="4000" type="card" class="carousel d-none d-sm-block" height="400px">
                    <el-carousel-item >
                        <img src="../../img/merge/ac1.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac2.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac3.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac4.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac5.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac6.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac7.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac8.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac9.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac10.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac11.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac12.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../img/merge/ac13.jpg" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                </el-carousel>
                <el-carousel :interval="4000" type="" class="carousel d-sm-none d-block" height="240px" arrow="always">
                    <el-carousel-item >
                        <img src="../../img/merge/ac1.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac2.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac3.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac4.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac5.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac6.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac7.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac8.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac9.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac10.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac11.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac12.png" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                    <el-carousel-item >
                        <img src="../../img/merge/ac13.jpg" alt="" srcset="" class="w-100 h-100">
                    </el-carousel-item>
                </el-carousel>
                <div class="carouselTitle">国际高校联展</div>
            </div>
        </div>
        
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .header-li {
        // margin-right: 40px;
    }
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }
    .carouselTitle {
        width: 100%;
        height: 34px;
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        margin: 0 auto;
        text-align: center;
    }
    .body-box{
        display: flex;
        flex-direction: column;
        justify-content: space-between; 
        min-height: 100vh;

    }
    @media (max-width:768px) {
        .con-top{
            margin-top: 100px;
        }
    }

    @media (min-width:768px) {
        .con-top{
            margin-top: 200px;
        }
    }
    [v-cloak] {
        display: none;
    }
    .el-carousel__arrow--left,.el-carousel__arrow--right{
        color: red !important;
        font-weight: bold !important;
        font-size: 18px !important;
    }
    .el-carousel__arrow{
        background-color: rgba(255, 0, 64, 0.238) !important;
    }
</style>
<script>
    //import {sign,getBanner,getuser,getIndexs} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                footbottom:123,
            };
        },
        created() {
           console.log("开始开发")
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            
            toPage(url){
                this.$router.push(url);
            }
        },
    };
</script>
